<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8346 6.66668L14.168 10M14.168 10L10.8346 13.3333M14.168 10L9.7513 10C9.30744 10.0048 8.86709 9.92083 8.45611 9.75312C8.04512 9.58541 7.67177 9.33729 7.35797 9.02334L1.66797 3.33334M1.66797 16.6667L5.83464 12.5"
      stroke="#1F2937"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.9987 6.66666L18.332 9.99999L14.9987 13.3333"
      stroke="#1F2937"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
